module.exports = __webpack_public_path__ + "static/media/DSC_0363.3f42ad34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0363.jpg
// module id = 576
// module chunks = 0